import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import styled from 'styled-components';

const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh;
`;

const SpinnerPage = () => {
  return (
    <SpinnerWrapper>
      <CircularProgress size={60} thickness={4.5} color="primary" />
    </SpinnerWrapper>
  );
};

export default SpinnerPage;
